import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./Translations/LenguageContext";

import "./App.css";
import "./Platform.css";
import "./PlatformLoaders.css";
import "./AppMobile.css";
import "./Directories.css";

import ScrollToTop from "./Functions/ScrollToTop";
import MainFrameHome from "./Website/Home/MainFrameHome";

import { logPageView } from "./Analytics";

import Register from "./Authentication/Register";
import Login from "./Authentication/Login";
import LoginPcPage from "./Authentication/LoginPCPage";
import Terms_And_Conditions from "./Policies/TermsConditions";
import Cookie_Policy from "./Policies/CookiesPolicy";
import Legal_Notes from "./Policies/LegalNotes";
import Privacy_Policy from "./Policies/PrivacyPolicy";
import MainFramdeAdmin from "./AdminPlatform/MainFrameAdmin";
import AcceptInvitation from "./Website/Invitation/AcceptInvitation";
import VerifyEmail from "./Authentication/VerifyEmail";
import EmailVerified from "./Authentication/EmailVerified";
import GoogleCallback from "./Callbacks/GoogleCallback";
import MainAbilitiesDirectory from "./Directories/MainAbilitiesDirectory";
import OutlookCallback from "./Callbacks/OutlookCallback";
import MainOnboarding from "./Onboarding/MainOnboarding";
import MainPricing from "./Website/Pricing/MainPricing";
import ContactSales from "./Website/Contact/ContactSales";
import HubspotCallback from "./Callbacks/HubspotCallback";
import OAuthMain from "./OAuth/OAuthMain";

const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return children;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainFrameHome />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/contact/sales" element={<ContactSales />} />
    <Route path="/mobile_device" element={<LoginPcPage />} />
    <Route path="/verify-email" element={<VerifyEmail />} />
    <Route path="/email-verify" element={<EmailVerified />} />
    <Route path="/onboarding/:onb_step" element={<MainOnboarding />} />

    <Route path="/pricing" element={<MainPricing />} />
    
    {/* Policies */}
    <Route path="/privacy" element={<Privacy_Policy />} />
    <Route path="/terms-and-conditions" element={<Terms_And_Conditions />} />
    <Route path="/cookie-policy" element={<Cookie_Policy />} />
    <Route path="/legal-notes" element={<Legal_Notes />} />

    {/* Invitation */}
    <Route path="/accept-invitation" element={<AcceptInvitation />} />

    {/* Platform */}
    <Route path="/e8console/*" element={<MainFramdeAdmin />} />

    {/* Directories */}
    <Route path="/directories/abilities" element={<MainAbilitiesDirectory />} />

    {/* Callbacks */}
    <Route path="/google-callback" element={<GoogleCallback />} />
    <Route path="/outlook-callback" element={<OutlookCallback />} />
    <Route path="/hubspot-callback" element={<HubspotCallback />} />

    {/* Oauth */}
    <Route path="/oauth/:org_id/:abty_id/:version" element={<OAuthMain />} />
  </Routes>
);

const ThemeController = () => {
  const location = useLocation();
  const [audioEnabled, setAudioEnabled] = useState(false);

  const unlockAudio = () => {
    if (audioEnabled) return;

    const audio = new Audio("/sound/click_sound.mp3");
    audio.volume = 0;

    audio.play()
      .then(() => setAudioEnabled(true))
      .catch(() => { });
  };


  useEffect(() => {
    unlockAudio()
    const root = window.document.documentElement;

    const isPlatform =
      location.pathname.startsWith("/e8console") ||
      location.pathname.startsWith("/google-callback") ||
      location.pathname.startsWith("/outlook-callback") ||
      location.pathname.startsWith("/onboarding") ||
      location.pathname.startsWith("/directories")

    root.removeAttribute("data-theme");

    if (!isPlatform) {
      root.setAttribute("data-theme", "light");
      return;
    }

    const applyTheme = () => {
      const savedTheme = localStorage.getItem("pe8-theme-preference");

      let themeToSet = savedTheme;

      if (!savedTheme || savedTheme === "system") {
        themeToSet = window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light";
      }

      root.setAttribute("data-theme", themeToSet);
    };

    applyTheme();

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleSystemChange = () => {
      const currentPref = localStorage.getItem("pe8-theme-preference");
      if (!currentPref || currentPref === "system") {
        applyTheme();
      }
    };

    mediaQuery.addEventListener("change", handleSystemChange);
    window.addEventListener("storage", applyTheme);

    return () => {
      mediaQuery.removeEventListener("change", handleSystemChange);
      window.removeEventListener("storage", applyTheme);
    };
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <ThemeController />

        <AnalyticsWrapper>
          <ScrollToTop />
          <AppRoutes />
        </AnalyticsWrapper>
      </Router>
    </LanguageProvider>
  );
};

export default App;